"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ToolTipProvider_1 = require("../tooltips/ToolTipProvider");
var configuration_1 = require("../configuration");
var mainViewController_1 = require("../mainViewController");
var mouseClickHandler_1 = require("../mouseClickHandler");
exports.multiGridClass = zebra.Class(zebra.ui.grid.Grid, [
    function (selectBehaviour, hoverFont) {
        this.selectedRows = new Array();
        this._observers = new Array();
        this.isShiftPressed = false;
        this.selectBehaviour = selectBehaviour;
        this.selectBehaviour.setGrid(this);
        this.toolTipHandler = new ToolTipProvider_1.ToolTipProvider(hoverFont);
        this.toolTipHandler.setGrid(this);
        this.$super();
    },
    function registerObserver(observer) {
        this._observers.push(observer);
    },
    function removeObserver(observer) {
        this._observers.splice(this._observers.indexOf(observer), 1);
    },
    function notifyObservers(arg) {
        this._observers.forEach(function (observer) {
            observer.update(arg);
        });
    },
    function getSelectedRows() {
        return this.selectedRows;
    },
    function setSelectedRows(rows) {
        this.selectedRows = rows;
        this.repaint();
    },
    function getLastSelectedRow() {
        return this.selectedRows[this.selectedRows.length];
    },
    function removeFromSelectedRows(rowToRemove) {
        this.selectBehaviour.removeSelectedRow(rowToRemove);
    },
    function clearAllSelectedRows() {
        this.selectBehaviour.clearAllSelectedRows();
    },
    function paintSelection(g) {
        var _this = this;
        if (g && this.editingRow < 0) {
            var offSelectionView = new zebra.util.rgb(configuration_1.PlanConfiguration.selectedRowInactive);
            this.views["offselection"] = offSelectionView;
        }
        var mySelectionView = new zebra.util.rgb(configuration_1.PlanConfiguration.selectedRow);
        var myCurrentSelectionView = new zebra.util.rgb(configuration_1.PlanConfiguration.currentSelectedRow);
        var selectedAndCorruptedView = new zebra.util.rgb(configuration_1.PlanConfiguration.selectedErrorRow);
        var selectedAndWarnView = new zebra.util.rgb(configuration_1.PlanConfiguration.selectedWarnRow);
        var corruptedView = new zebra.util.rgb(configuration_1.PlanConfiguration.corruptedRow);
        var warnView = new zebra.util.rgb(configuration_1.PlanConfiguration.warningRow);
        if (g && this.selectedRows) {
            this.rows.forEach(function (row, rowIndex) {
                var x = _this.visibility.fc[1];
                var y = _this.getRowY(rowIndex);
                var h = _this.rowHeights[rowIndex];
                if (_.contains(_this.selectedRows, rowIndex)) {
                    var theRow = void 0;
                    if (_this.rows) {
                        theRow = _this.rows[rowIndex];
                    }
                    for (var i = _this.visibility.fc[0]; i <= _this.visibility.lc[0]; i++) {
                        if (rowIndex === _this.getLatestRow()) {
                            myCurrentSelectionView.paint(g, x, y, _this.colWidths[i], h, _this);
                        }
                        else {
                            mySelectionView.paint(g, x, y, _this.colWidths[i], h, _this);
                        }
                        if (theRow) {
                            if (theRow.rowState === mainViewController_1.rowState.Error || theRow.rowState === mainViewController_1.rowState.ErrorMissed67) {
                                selectedAndCorruptedView.paint(g, x, y, _this.colWidths[i], h, _this);
                            }
                            else if (theRow.rowState === mainViewController_1.rowState.Warning) {
                                selectedAndWarnView.paint(g, x, y, _this.colWidths[i], h, _this);
                            }
                        }
                        x += (_this.colWidths[i] + _this.lineSize);
                    }
                }
                else {
                    for (var i = _this.visibility.fc[0]; i <= _this.visibility.lc[0]; i++) {
                        if (row.rowState === mainViewController_1.rowState.Error || row.rowState === mainViewController_1.rowState.ErrorMissed67) {
                            corruptedView.paint(g, x, y, _this.colWidths[i], h, _this);
                        }
                        else if (row.rowState === mainViewController_1.rowState.Warning) {
                            warnView.paint(g, x, y, _this.colWidths[i], h, _this);
                        }
                    }
                }
            });
        }
    },
    function select(row, b) {
        return;
    },
    function getLatestRow() {
        return this.selectedRows[this.selectedRows.length - 1];
    },
    function mousePressed(event) {
        if (event.absX !== this._lastX && event.clicks === 1) {
            try {
                this.selectBehaviour.mouseClicked(event);
            }
            catch (error) {
            }
        }
        this._lastX = event.absX;
    },
    function keyPressed(event) {
        this.selectBehaviour.keyPressed(event);
    },
    function keyReleased(event) {
        this.selectBehaviour.keyReleased(event);
    },
    function addClickHandling(condition, action) {
        this.clickCondition = condition;
        this.clickAction = action;
    },
    function mouseClicked(event) {
        mouseClickHandler_1.MouseClickHandler.registerEvent(this, event, this.clickCondition, this.clickAction);
        this.$super(event);
    }
]);
//# sourceMappingURL=MultipleSelectionGrid.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/grids/MultipleSelectionGrid.js
// module id = 77
// module chunks = 0